<template>
  <div
    class="h-auto w-full rounded-lg overflow-hidden md:min-h-[488px] bg-[white]"
  >
    <div
      id="cal-container"
      class="md:min-h-[488px]"
      style="position: relative; width: 100%; height: 100%; overflow: hidden"
    >
      <div
        class="hidden-bar hidden md:block absolute bottom-0 left-0 right-0 h-64 z-10"
      ></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
onMounted(() => {
  useHead({
    script: [
      {
        innerHTML: `
          (function (C, A, L) {
        let p = function (a, ar) {
          a.q.push(ar);
        };
        let d = C.document;
        C.Cal =
          C.Cal ||
          function () {
            let cal = C.Cal;
            let ar = arguments;
            if (!cal.loaded) {
              cal.ns = {};
              cal.q = cal.q || [];
              d.head.appendChild(d.createElement("script")).src = A;
              cal.loaded = true;
            }
            if (ar[0] === L) {
              const api = function () {
                p(api, arguments);
              };
              const namespace = ar[1];
              api.q = api.q || [];
              typeof namespace === "string"
                ? (cal.ns[namespace] = api) && p(api, ar)
                : p(cal, ar);
              return;
            }
            p(cal, ar);
          };
      })(window, "https://app.cal.com/embed/embed.js", "init");`,
        type: "text/javascript",
      },
    ],
  });

  setTimeout(() => {
    if (!import.meta.client) return;

    (window as any).Cal("init", { origin: "https://cal.com" });
    (window as any).Cal("inline", {
      elementOrSelector: "#cal-container",
      calLink: "hyperfocused/demo",
      layout: "month_view",
    });
    (window as any).Cal("ui", {
      theme: "light",
      styles: {
        branding: { brandColor: "#2b1c15" },
      },
      hideEventTypeDetails: false,
      layout: "month_view",
    });
  }, 100);
});
</script>

<style lang="scss"></style>
